/* eslint-disable @typescript-eslint/no-magic-numbers */
import Constants from '@/Constants';
import { useApiQuery } from '@/hooks/useApi';
import { makeRequest } from '@/services/api';
import useStore from '@/store';
import { createKey } from '@/utils/helper';

const useGetServerTime = () => {
  const { callGetServerTime } = useStore();
  return useApiQuery({
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    retryOnMount: true,
    refetchInterval: 50 * 1000,
    queryKey: createKey(Constants.GET_SERVER_TIME_URL, {}),
    queryFn: async () => {
      const result = await makeRequest<{ serverTime: string }>(
        Constants.GET_SERVER_TIME_URL,
        {},
        {},
      );
      return result;
    },
    enabled: !!localStorage.getItem('accessToken') && callGetServerTime,
    apiErrorHandling: false,
    networkErrorHandling: false,
    select: (data) => {
      /*
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
      const serverTime = data.headers['date'];
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      if (onSuccess) onSuccess(serverTime);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      */
      return data.data;
    },
  });
};

export default useGetServerTime;
